import { render, staticRenderFns } from "./SaleOrderEventCreate.vue?vue&type=template&id=07a61d3a&scoped=true"
import script from "./SaleOrderEventCreate.vue?vue&type=script&lang=js"
export * from "./SaleOrderEventCreate.vue?vue&type=script&lang=js"
import style0 from "./SaleOrderEventCreate.vue?vue&type=style&index=0&id=07a61d3a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07a61d3a",
  null
  
)

export default component.exports